module.exports = __webpack_public_path__ + "img/Nauru.d0d6b81a.svg";